import { render, staticRenderFns } from "./aoi-list-item.vue?vue&type=template&id=eb1f19c6&scoped=true&"
import script from "./aoi-list-item.vue?vue&type=script&lang=js&"
export * from "./aoi-list-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb1f19c6",
  null
  
)

export default component.exports